import { Stack } from '@src/shared/ui/layout';
import type { ReactNode } from 'react';
import { PAGE_LAYOUT_SCROLL_CONTAINER_ID } from './constants';
import Header from './Header';
import PageContentRow from './PageContentRow';

type LayoutProps = {
  children: ReactNode;
  fillHeight?: boolean;
};

export default function Layout({ children, fillHeight = false }: LayoutProps) {
  return (
    <Stack
      id={PAGE_LAYOUT_SCROLL_CONTAINER_ID}
      useFlexGap
      spacing={1.25}
      sx={
        fillHeight
          ? { height: '100%', minHeight: 0, overflowY: 'auto' }
          : { overflowY: 'auto' }
      }
    >
      <Header />
      <PageContentRow fillHeight={fillHeight}>{children}</PageContentRow>
    </Stack>
  );
}
